var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar',{staticClass:"primaryText--text sub-header elevation-3",attrs:{"height":"48px","color":"primary"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }